import { T } from "./theme";

export default function AdminTable({ t, headers, rows }) {
  if (!rows.length) return <p style={{ color: T.muted }}>{t("admin.empty")}</p>;
  return (
    <div style={{ overflowX: "auto" }}>
      <table className="admin-table" style={{ width: "100%", borderCollapse: "collapse", marginTop: 14 }}>
        <thead>
          <tr>{headers.map((header) => (
            <th key={header} style={{ textAlign: "left", color: T.muted, borderBottom: `1px solid ${T.border}`, padding: 10 }}>{header}</th>
          ))}</tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>{row.map((cell, cellIndex) => (
              <td key={cellIndex} style={{ borderBottom: `1px solid ${T.border}`, padding: 10 }}>{cell}</td>
            ))}</tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
